import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { Modal, ModalContent, ModalFooter, ModalHeader } from './ng-modal.component';



export class NgModalModule {
    
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        Modal, ModalContent, ModalFooter, ModalHeader
    ],
    providers: [],
    exports: [
        Modal, ModalContent, ModalFooter, ModalHeader
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
